// Module
var code = "<p><a href=\"introduction/committee\">Kurul üyeleri</a> blok zincirine ait ücretler, blok süreleri ve diğer bir çok şey gibi dinamik parametrelerin değiştirilmesini teklif edebilirler. BitShares&#39;in nasıl işlediğine dair derin bilgi gerektiren büyük bir sorumluluk pozisyonudur.</p> ";
// Exports
export default code;